import PriceWrapper from './PriceWrapper.vue'

export default PriceWrapper
